/**
 * cardGridCarousel
 */

import $ from 'jquery';
import 'slick-carousel';

// Module dependencies
import 'protons';

// Module styles
import './_card-grid-carousel.scss';

// Module template
import './_card-grid-carousel.twig';

export const name = 'cardGridCarousel';

export const defaults = {
  dummyClass: 'js-cardGridCarousel-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

function initCarousel($carouselWrapper) {
  const $carousel = $carouselWrapper.find('.card-grid-carousel__carousel');
  const globalSettings = {
    pauseOnHover: true,
    draggable: false,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    mobileFirst: true,
    accessibility: true,
    cssEase: 'ease',
    infinite: false,
    respondTo: 'window',
    touchMove: true,
    autoplay: false,
    appendDots: $carouselWrapper.find('.card-grid-carousel-indicators'),
    fade: $carousel.data('fade'),
    slidesToShow: 1,
  };
  const responsiveSettings = {
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: $carousel.data('slidesToShow'),
        },
      },
    ],
  };

  if ($carousel.data('slidesToShow') >= 2) {
    $carousel.slick({
      ...globalSettings,
      ...responsiveSettings,
    });
  } else {
    $carousel.slick({
      ...globalSettings,
      slidesToShow: $carousel.data('slidesToShow'),
    });
  }
}

export function enable($context) {
  const $carousels = $('.card-grid-carousel__carousel-container', $context);
  // Bail if component does not exist
  if (!$carousels.length) {
    return;
  }

  // Initiate carousel
  $carousels.each((i, el) => {
    initCarousel($(el));
  });

  // Add class to wyswyig added buttons
  $('.card-grid-carousel .body-field .fm-btn')
    .parent('p')
    .addClass('fm-btn-wrapper');
}

export default enable;
